import axios from "axios";
import {
  getInfopersonFailure,
  getInfopersonStart,
  getInfopersonSuccess,
  updateInfopersonFailure,
  updateInfopersonStart,
  updateInfopersonSuccess,
} from "./InfopersonActions";
import { API_URL } from "../../config/runtimeConfig";

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const getInfoperson = async (dispatch) => {
  dispatch(getInfopersonStart());
  try {
    const res = await axiosInstance.get(`/user/infoperson`, {
      headers: {
        token:
          `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
      },
    });
    dispatch(getInfopersonSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(getInfopersonFailure(err.response.data.message));
    } else {
      dispatch(getInfopersonFailure("Unkown Error"));
    }
  }
};

export const updateInfoperson = async (
  dispatch,
  nom,
  tel1,
  tel2,
  email,
  wilaya,
  commune,
) => {
  dispatch(updateInfopersonStart());
  try {
    const res = await axiosInstance.post(
      `/user/infoperson/update`,
      { nom, tel1, tel2, email, wilaya, commune },
      {
        headers: {
          token:
            `nweadmin ` + JSON.parse(localStorage.getItem("user")).accessToken,
        },
      },
    );
    dispatch(updateInfopersonSuccess(res.data));
  } catch (err) {
    if (err.response) {
      dispatch(updateInfopersonFailure(err.response.data.message));
    } else {
      dispatch(updateInfopersonFailure("Unkown Error"));
    }
  }
};
